import React from 'react'
import RevenueChartM from './revenueChartM/RevenueChartM'
import RevenueChartMPro from './revenueChartM/RevenueChartMPro'
import RevenueChartMAll from './revenueChartM/RevenueChartMAll'

const RevenueCardM = () => {
    return (
        <div className='w-full h-fit text-sm font-color-4 flex flex-col'>
            <div className='flex justify-between items-center'>
                <p>Monatsumsatz</p>
                <button
                    className='hidden ml-4 px-3 py-2 bg-color-5 font-color-1 text-sm flex items-center shadow-sm border border-color-2 rounded-lg font-medium'>
                    Report anzeigen
                </button>
            </div>
            <div className='font-bold text-xl py-2 font-color-4'><RevenueChartMAll/></div>
            <div className='flex items-center'>
                <div className='font-color-6 ml-1'>Umsatz, Kosten, Rohertrag 1</div>
            </div>
            <div className='flex justify-center items-center w-full py-2'>
                <RevenueChartM/>
            </div>
            <RevenueChartMPro/>
        </div>

    )
}

export default RevenueCardM